import React from "react"
import { Box, makeStyles, Theme, FormGroup } from "@material-ui/core"
import { InputLabel } from "../@citydna/common/InputLabel"
import { CommonFieldFields } from "./CommonFieldFields"
import { CommonFieldOptions } from "./CommonFieldOptions"

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme>(theme => ({
  root: {},
  fields: {
    marginRight: theme.spacing(4),
    paddingRight: theme.spacing(5),
    flexGrow: 1,
    borderRight: `1px solid ${
      theme.palette.type === "dark"
        ? theme.palette.grey[500]
        : theme.palette.grey[100]
    }`,
  },
  options: {
    maxWidth: 200,
  },
}))

export const TextFieldFields: React.FC = () => {
  /** Get scoped CSS classes */
  const classes = useStyles()

  return (
    <Box display="flex">
      <Box className={classes.fields}>
        <CommonFieldFields />
      </Box>
      <Box className={classes.options}>
        <InputLabel>Field options</InputLabel>
        <FormGroup>
          <CommonFieldOptions />
        </FormGroup>
      </Box>
    </Box>
  )
}
